import React, { Component } from "react";
import { Col, Container } from "react-bootstrap";
import Logo from "../Images/cite/Logo.png";

export default class ItemModal extends Component {
  render() {
    return (
      <header className="cite__myHeader">
        <Container>
          <div className="cite__headerDetail">
            <div className="cite__headerDetailCol">
              <Col md={6} style={{ textAlign: "right" }}>
                <h4 style={{ marginRight: 20, fontWeight: "bold" }}>
                  استناددهی آنلاین
                </h4>
                <p style={{ marginRight: 20, textAlign: "justify" }}>
                  استناددهی آنلاین به شما کمک می‌کند که بدون نیاز به ایجاد حساب
                  کاربری و یا نصب نرم‌افزار، با وارد کردن اطلاعات کتابشناختی
                  مدنظرتان بلافاصله کتابنامه خود را تولید کنید. این ابزار انواع
                  شیوه‌نامه‌های فارسی و انگلیسی را پشتیبانی می‌کند.
                </p>
              </Col>
              <Col md={6}>
                {" "}
                <img
                  height={200}
                  alt="logo"
                  src={Logo}
                  onClick={() => {
                    this.setState({ show_rating: true });
                  }}
                />
              </Col>
            </div>
          </div>
        </Container>
      </header>
    );
  }
}
